import { useCallback } from "react";
import propTypes from "prop-types";
import addLineItemToUrl from "./addLineItemToUrl";

const AdvertLink = ({ url, lineItemId, children, onClick, className }) => {
  const urlWithLineItemId = addLineItemToUrl(url, lineItemId);

  const onAdvertLinkClick = useCallback(
    (event) => {
      const customEvent = new CustomEvent("adverts.onClick", {
        cancelable: true,
        detail: { href: url }
      });

      onClick(customEvent);

      if (customEvent.defaultPrevented) {
        event.preventDefault();
      }
    },
    [onClick, url]
  );

  return (
    <a
      href={urlWithLineItemId}
      onClick={onAdvertLinkClick}
      className={className}
    >
      {children}
    </a>
  );
};

AdvertLink.propTypes = {
  url: propTypes.string,
  lineItemId: propTypes.string,
  onClick: propTypes.func,
  className: propTypes.string,
  children: propTypes.oneOfType([
    propTypes.arrayOf(propTypes.node),
    propTypes.node
  ]).isRequired
};

export default AdvertLink;
